module.exports = __webpack_public_path__ + "img/icon_pause_1.5d8b82dc.svg";